import {loadingStarted} from "../../../global/GlobalActions";
import {encodeForm} from "../../../util/HtmlHelper";
import {LOGIN} from "../../../global/BackendUrls";
import axios from "axios/index";
import {newTokenFromBackendResponse, setTokenAction} from "../shared/TokenActions";
import {handleFetchError, handleFetchSuccess} from "../../../global/GlobalHandlers";

export function loginAsyncAction(email, password) {
    const actionAsFunction = function (dispatch) {
        loadingStarted(dispatch);

        const promise = axios.post(
            LOGIN,

            encodeForm({
                username: email,
                password: password,
                grant_type: 'password',
                long_session: true
            }),

            {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        );

        promise.then(function (response) {
            dispatch(setTokenAction(newTokenFromBackendResponse(response)));
            return response;
        })
            .then(() => handleFetchSuccess(dispatch, null))
            .catch((error) => handleFetchError(error, dispatch, true));
    }
    return actionAsFunction;  //so the action itself is a function
}
